import React from "react";
import { Stack, Card, Tooltip, Zoom } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { Globals } from "../../../helpers/globals";
import SegmentIcon from "@mui/icons-material/Segment";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AssessmentIcon from "@mui/icons-material/Assessment";
import StorageIcon from "@mui/icons-material/Storage";
import WorkIcon from "@mui/icons-material/Work";
/**
 * Props type for the AppBar component.
 */
type AppBarProps = {
    /**
     * Additional class names to apply to the AppBar.
     */
    className?: string;

    /**
     * Spacing between icons on the right side of the app bar (in pixels).
     */
    iconSpacing?: number;

    /**
     * Spacing between buttons on the left side of the app bar (in pixels).
     */
    buttonSpacing?: number;

    /**
     * Size of icons on the right side of the app bar (in rem).
     */
    iconSizeXRem?: string;

    /**
     * Size of icons on the left side of the app bar (in rem).
     */
    iconSizeYRem?: string;

    /**
     * Additional MUI-specific styles to apply to the AppBar.
     */
    sx?: any;
};

export default function AppsRow(params: AppBarProps) {
    const location = useLocation();
    const [final_sx, _] = React.useState({
        ...(params.sx ?? {}),
        width: params.sx.width ?? "100%",
        paddingY: params.sx.paddingY ?? 1,
        paddingX: params.sx.paddingX ?? 2,
    });
    React.useEffect(() => {
        Globals.retrieveMe();
    }, []);

    const currentUser = Globals.currentUserValue;

    return (
        <Card sx={{ ...final_sx }}>
            <Stack direction="row" justifyContent="space-between">
                <Link
                    to="/uploads"
                    type="button"
                    className="btn btn-primary mr-3"
                >
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        spacing={"10rem"}
                    >
                        <CloudUploadIcon /> Uploads
                    </Stack>
                </Link>
                <Link
                    to="/reporting/efiling"
                    type="button"
                    className="btn btn-primary float-right mr-3"
                >
                    <AssessmentIcon />
                    eFile Reports
                </Link>
                <Link
                    to="/mycases"
                    type="button"
                    className="btn btn-primary float-right mr-3"
                >
                    <WorkIcon />
                    My Cases
                </Link>
                {currentUser?.role && currentUser.role!.key! >= 100 && (
                    <Link
                        to="/queue/available"
                        type="button"
                        className="btn btn-primary float-right mr-3"
                    >
                        <SegmentIcon />
                        Available queue
                    </Link>
                )}
                {currentUser?.role && currentUser.role!.key! >= 500 && (
                    <Link
                        to="/matter-managment"
                        type="button"
                        className="btn btn-primary float-right mr-3"
                    >
                        <StorageIcon />
                        eMatterMagic
                    </Link>
                )}
            </Stack>
        </Card>
    );
}
